export default "__VITE_ASSET__019bd2b1__"